import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col } from '../../components/Col';
import { CustomButton } from '../../components/CustomButton';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import styles from './Atividades.scss';
import AtividadesItem from './AtividadesItem';
import { AddIcon } from 'assets/icons/AddIcon';

const rootClassName = styles.rootClassName;

class Atividades extends Component {
  allowEditButton() {
    return this.props.auth.userPermissions.contratos.entePrivado.edit
      ? true
      : false;
  }

  render() {
    return (
      <div
        className={getMergedClassNames([
          rootClassName,
          typeof this.props.className === 'string' ? this.props.className : '',
        ])}
      >
        <Table className={rootClassName + '-table'}>
          <TableHead>
            <TableRow>
              {this.props.contratosEntePrivado.contratoEditing.atividades
                .length > 0 ? (
                <>
                  {this.allowEditButton() ? (
                    <TableCell
                      className={
                        rootClassName + '-cell ' + rootClassName + '-edit-cell'
                      }
                    ></TableCell>
                  ) : null}
                  <TableCell className={rootClassName + '-cell'}>
                    {this.props.languageValues.atividadeLabel}
                  </TableCell>
                  <TableCell className={rootClassName + '-cell'}>
                    {this.props.languageValues.custoLabel}
                  </TableCell>
                  <TableCell
                    className={
                      rootClassName + '-cell ' + rootClassName + '-toggle-cell'
                    }
                  ></TableCell>
                </>
              ) : null}
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.contratosEntePrivado.contratoEditing.atividades.map(
              (atividade, index) => {
                return (
                  <AtividadesItem
                    atividade={atividade}
                    key={index}
                    fieldDisabled={this.props.fieldDisabled}
                    changeAtividades={this.props.changeAtividades}
                  />
                );
              }
            )}
          </TableBody>
        </Table>
        {this.props.contratosEntePrivado.contratoEditing.atividades.length ===
        0 ? (
          <Col
            cols={[12, 12, 12, 12, 12]}
            className={rootClassName + '-hidden-cadastro-buttom'}
          >
            <CustomButton
              className={rootClassName + `-modal-cadastro-buttom`}
              label={this.props.languageValues.cadastroAtividadeButtom}
              theme='pufvYellow'
              onClick={this.props.addAtividade}
              rightIcon={<AddIcon />}
              disabled={
                !this.props.contratosEntePrivado.contratoEditing
                  .escolaCompromissoCheck || this.props.fieldDisabled()
              }
            />
          </Col>
        ) : null}
      </div>
    );
  }
}

Atividades.propTypes = {
  escolaCompromissoCheckChanged: PropTypes.func.isRequired,
  addAtividade: PropTypes.func.isRequired,
  changeAtividades: PropTypes.func.isRequired,
  fieldDisabled: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  languageValues: state.languages.languageValues,
  contratosEntePrivado: state.contratosEntePrivado,
});

export default connect(mapStateToProps, null)(Atividades);
